import { Order } from '../../../../../../clients/quipli-service/order/order';
import { OffRentRequest } from '../../../../../../clients/quipli-service/order/order';
import { InventoryReturnRequest } from '../../../../../../clients/quipli-service/order/order';
import { FinancialSummary } from '../../../../../../clients/quipli-service/financials/financials';
import { CalculateFinancialSummaryRequest } from '../../../../../../clients/quipli-service/financials/financials';
import { CalculateOverageChargeResult, ProductType } from '../../../../../../clients/quipli-service/product/product';
import { HourOverageOverride } from '../../../shared/hooks/use-hour-overage-calculation';
import { FuelCharge } from '../../../shared/types/fuel-charge-types';
import { OffRentGridProductRow } from './off-rent-grid-product-row';
import { OffRentUnitRow } from './off-rent-unit-row';

export const OffRentGridProducts = ({
  order,
  offRentRequest,
  inventoryReturnRequest,
  existingSummary,
  lateChargeSummary,
  waiveLateCharge,
  currency,
  setLateChargeSummaryRequest,
  unitTrackingType,
  setInventoryReturnRequest,
  getOverageForUnit,
  getOverrideForUnit,
  updateOverageOverride,
  getFuelChargeForUnit,
  updateFuelCharge,
  fuelCharges,
  isCalculating,
}: {
  order: Order;
  offRentRequest: OffRentRequest;
  inventoryReturnRequest: InventoryReturnRequest | undefined;
  existingSummary: FinancialSummary | undefined;
  lateChargeSummary: FinancialSummary | undefined;
  waiveLateCharge: boolean;
  currency: Dinero.Currency | undefined;
  setLateChargeSummaryRequest: React.Dispatch<React.SetStateAction<CalculateFinancialSummaryRequest | undefined>>;
  unitTrackingType: 'serialNumber' | 'unitNumber';
  setInventoryReturnRequest: React.Dispatch<React.SetStateAction<InventoryReturnRequest | undefined>>;
  getOverageForUnit: (orderProductId: number, unitId: number) => CalculateOverageChargeResult | undefined;
  getOverrideForUnit: (orderProductId: number, unitId: number) => HourOverageOverride | undefined;
  updateOverageOverride: (orderProductId: number, unitId: number, value: HourOverageOverride) => void;
  getFuelChargeForUnit: (orderProductId: number, unitId: number) => FuelCharge | undefined;
  updateFuelCharge: (orderProductId: number, unitId: number, updates: { amount: number; productId?: number }) => void;
  fuelCharges: FuelCharge[];
  isCalculating: boolean;
}) => {
  return (
    <>
      {order.products
        .filter((op) => offRentRequest.offRentProducts.map((orp) => orp.productId).includes(op.id))
        .map((op) => {
          const isSelectedForReturn = inventoryReturnRequest?.orderProductIds.includes(op.id);
          const existingAmount = existingSummary?.lineItems.find(
            (li) =>
              ((op.product.type === ProductType.Custom && li.type === 'CustomProduct') || li.type == 'Product') &&
              li.id === op.id.toString(),
          )?.amount;
          const lateChargeAmount = lateChargeSummary?.lineItems.find(
            (li) =>
              ((op.product.type === ProductType.Custom && li.type === 'CustomProduct') || li.type == 'Product') &&
              li.id === op.id.toString(),
          )?.amount;
          const value = lateChargeAmount && existingAmount && lateChargeAmount.subtract(existingAmount);

          return (
            <>
              <OffRentGridProductRow
                orderProduct={op}
                isSelectedForReturn={isSelectedForReturn}
                existingAmount={existingAmount}
                lateChargeAmount={lateChargeAmount}
                waiveLateCharge={waiveLateCharge}
                order={order}
                currency={currency}
                value={value}
                setLateChargeSummaryRequest={setLateChargeSummaryRequest}
              />

              <OffRentUnitRow
                order={order}
                orderProduct={op}
                isSelectedForReturn={isSelectedForReturn}
                inventoryReturnRequest={inventoryReturnRequest}
                unitTrackingType={unitTrackingType}
                setInventoryReturnRequest={setInventoryReturnRequest}
                getOverageForUnit={getOverageForUnit}
                getOverrideForUnit={getOverrideForUnit}
                updateOverageOverride={updateOverageOverride}
                getFuelChargeForUnit={getFuelChargeForUnit}
                updateFuelCharge={updateFuelCharge}
                existingSummary={existingSummary}
                fuelCharges={fuelCharges}
                currency={currency}
                isCalculating={isCalculating}
              />
            </>
          );
        })}
    </>
  );
};
